module.exports = __webpack_public_path__ + "img/20200214184414YY截图20200214183957.a0e3b2c1.png";